<template>
  <div>
    <div class v-if="type==6">
      <el-form label-position="left" label-width="130px" class="info_content" size='large'>
        <el-form-item label="账号名称">
          <el-input :value="user_info.nickname" class="username" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="所属电商" v-if="user_info.store_type!=0">
          <el-input value="京东" class="username" :disabled="true" v-if="user_info.store_type==1"></el-input>
          <el-input value="天猫" class="username" :disabled="true" v-if="user_info.store_type==2"></el-input>
          <el-input value="淘宝" class="username" :disabled="true" v-if="user_info.store_type==3"></el-input>
          <el-input value="苏宁" class="username" :disabled="true" v-if="user_info.store_type==4"></el-input>
          <el-input value="考拉" class="username" :disabled="true" v-if="user_info.store_type==5"></el-input>
          <el-input value="抖音小店" class="username" :disabled="true" v-if="user_info.store_type==6"></el-input>
          <el-input value="拼多多" class="username" :disabled="true" v-if="user_info.store_type==7"></el-input>
        </el-form-item>
        <el-form-item label="注册手机号">
          <el-input :value="user_info.tel" class="username" :disabled="true"></el-input>
        </el-form-item>

        <!-- <el-form-item
          label="主营类目"
          v-if="user_info.smgscy1!='null'||user_info.smgscy2!='null'||user_info.smgscy3!='null'"
        >
          <el-input
            :value="user_info.smgscy1"
            class="leimu"
            :disabled="true"
            v-if="user_info.smgscy1!='null'"
          ></el-input>
          <el-input
            :value="user_info.smgscy2"
            class="leimu ml-10"
            :disabled="true"
            v-if="user_info.smgscy2!='null'"
          ></el-input>
          <el-input
            :value="user_info.smgscy3"
            class="leimu ml-10"
            :disabled="true"
            v-if="user_info.smgscy3!='null'"
          ></el-input>
        </el-form-item>-->
        <el-form-item label="关联店铺">
          <div v-if="user_info.store_names.length!=0">
            <div class v-for="(item,index) in user_info.store_names" :key="item.store_name">
              <span class="my-store" v-if="item.platform=='jingdong'">【京东】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='tianmao'">【天猫】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='taobao'">【淘宝】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='suning'">【苏宁】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='kaola'">【考拉】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='douyin'">【抖音小店】{{item.store_name}}</span>
              <span class="my-store" v-if="item.platform=='pinduoduo'">【拼多多】{{item.store_name}}</span>
            </div>
          </div>
          <div class v-else>
            <span class="my-store">暂无</span>
          </div>
          <div>注：如关联店铺有误，请联系您的对接招商经理进行修改</div>
        </el-form-item>
        <el-form-item label="企业营业执照副本">
          <Upsome
            :file_list="file_list"
            :type="1"
            :disabled="disabled"
            :limits="limits"
            @getPic="getPic"
          ></Upsome>
        </el-form-item>
        <el-form-item label>
          <div v-if="type==6">
            <el-button type="primary" @click="setAdd" v-if="edit==1">添加营业执照</el-button>
            <div v-if="edit==2">
              <el-button @click="cancelAdd">取消</el-button>
              <el-button type="primary" @click="saveUserImg">保存</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="type==1||type==4||type==5||type==3">
      <el-form label-position="left" label-width="130px" class="info_content" size='large'>
        <el-form-item label="账号名称">
          <el-input :value="user_info.nickname" class="username" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="注册手机号">
          <el-input :value="user_info.tel" class="username" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item
          label="主营类目"
          v-if="type==3&&(user_info.smgscy1!=null||user_info.smgscy2!=null||user_info.smgscy3!=null)"
        >
          <el-input
            :value="user_info.smgscy1"
            class="leimu"
            :disabled="true"
            v-if="user_info.smgscy1!=null"
          ></el-input>
          <el-input
            :value="user_info.smgscy2"
            class="leimu ml-10"
            :disabled="true"
            v-if="user_info.smgscy2!=null"
          ></el-input>
          <el-input
            :value="user_info.smgscy3"
            class="leimu ml-10"
            :disabled="true"
            v-if="user_info.smgscy3!=null"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Upsome from "../template/upsome.vue";
export default {
  name: "myinfo",
  components: {
    Upsome: Upsome
  },
  data() {
    return {
      api: {
        getUserInfo: "/home/getUserInfo",
        saveUserImg: "home/saveUserImg" //保存营业执照
      },
      user_info:{},
      outerVisible: false,
      limits: 100,
      file_list: [], //营业执照列表
      disabled: true,
      edit: 1, //是否可以编辑
      store_img: "", //保存的图片链接
      once: 1, //禁止二次点击
      type: "", //1淘客 2内部招商 3短视频机构 4自媒体机构 5渠道 6电商独立店铺',
    };
  },

  created() {
    this.getUserInfo();
  },
  methods: {
    seeSomepic() {
      this.outerVisible = true;
    },
    getUserInfo() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.getUserInfo,
        params: data
      })
        .then(res => {
          if (res.code == 1) {
            _this.user_info = res.data;
             console.log(this.user_info)
            let img = [];
            if (res.data.store_img) {
              let file = res.data.store_img.split(",");
              for (let i = 0; i < file.length; i++) {
                let json = {
                  url: file[i]
                };
                img.push(json);
              }
            }
            this.file_list = img;
            this.store_img = res.data.store_img;
            this.type = res.data.type;
            if(res.data.type==7){
              this.$router.push({
                name:'usercalendar',
                query:{}
              })
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    setAdd() {
      //添加图片
      this.edit = 2;
      this.disabled = false;
    },
    cancelAdd() {
      this.edit = 1;
      this.disabled = true;
      this.getUserInfo();
    },
    getPic(data) {
      //获得自组件的图片
      this.store_img = data;
    },
    saveUserImg() {
      //保存营业执照
      let _this = this;
      if (!this.store_img) {
        this.$message.warning("请选择营业执照");
        return false;
      }
      this.$http({
        method: "POST",
        url: _this.api.saveUserImg,
        data: {
          store_img: this.store_img
        }
      }).then(res => {
        if (res.code == 1) {
          this.$message.success(res.msg);
          _this.edit = 1;
          this.disabled = true;
        } else {
          this.$message.warning(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.info_content {
  margin-top: 25px;
  margin-left: 35px;
}
.username {
  width: 278px;
}
.leimu {
  width: 86px;
}
.ml-10 {
  margin-left: 10px;
}
.mb-18 {
  margin-bottom: 18px;
}
.suoshu {
  font-size: 14px;
  color: #606266;
  float: left;
}
.zhizhao {
  float: left;
  margin-left: 22px;
  width: 300px;
  height: 300px;
  cursor: pointer;
}
.mask-zhizhao {
  max-width: 400px;
}
.center {
  text-align: center;
}
.my-store {
  display: inline-block;
  line-height: 32px;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  color: #c0c4cc;
  border-radius: 4px;
  padding: 0 15px;
  margin-bottom: 15px;
}
</style>
